import { render, staticRenderFns } from "./ListUsers.vue?vue&type=template&id=2232f706&scoped=true"
import script from "./ListUsers.vue?vue&type=script&lang=js"
export * from "./ListUsers.vue?vue&type=script&lang=js"
import style0 from "./ListUsers.vue?vue&type=style&index=0&id=2232f706&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2232f706",
  null
  
)

export default component.exports